// TAG 1: Load amplitude
(function(e,t){var n=e.amplitude||{_q:[],_iq:{}};var r=t.createElement("script")
;r.type="text/javascript";r.async=true
;r.src="https://cdn.amplitude.com/libs/amplitude-4.5.2-min.gz.js"
;r.onload=function(){if(e.amplitude.runQueuedFunctions){
e.amplitude.runQueuedFunctions()}else{
console.log("[Amplitude] Error: could not load SDK")}}
;var i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i)
;function s(e,t){e.prototype[t]=function(){
this._q.push([t].concat(Array.prototype.slice.call(arguments,0)));return this}}
var o=function(){this._q=[];return this}
;var a=["add","append","clearAll","prepend","set","setOnce","unset"]
;for(var u=0;u<a.length;u++){s(o,a[u])}n.Identify=o;var c=function(){this._q=[]
;return this}
;var l=["setProductId","setQuantity","setPrice","setRevenueType","setEventProperties"]
;for(var p=0;p<l.length;p++){s(c,l[p])}n.Revenue=c
;var d=["init","logEvent","logRevenue","setUserId","setUserProperties","setOptOut","setVersionName","setDomain","setDeviceId","setGlobalUserProperties","identify","clearUserProperties","setGroup","logRevenueV2","regenerateDeviceId","groupIdentify","logEventWithTimestamp","logEventWithGroups","setSessionId","resetSessionId"]
;function v(e){function t(t){e[t]=function(){
e._q.push([t].concat(Array.prototype.slice.call(arguments,0)))}}
for(var n=0;n<d.length;n++){t(d[n])}}v(n);n.getInstance=function(e){
e=(!e||e.length===0?"$default_instance":e).toLowerCase()
;if(!n._iq.hasOwnProperty(e)){n._iq[e]={_q:[]};v(n._iq[e])}return n._iq[e]}
;e.amplitude=n})(window,document);


const amplitudeAPIKey = "3fbf25d58c3cce92f0e6609904a37cc9"; // PROD
const SESSION_KEY = 'USER_SESSION';
const UTMS_KEY = '5A_UTMS';
let currentSession;

(() => {
const SEO_ORIGINS = [/https?:\/\/(www\.)?bing\./, /https?:\/\/(www\.)?google\./];
const isSEOReferrer = () => SEO_ORIGINS.some((regex) => regex.test(window.document.referrer));
const getReferrer = () => window.document.referrer || null;

const getReferringDomain = (referrer) => {
try {
    const url = new URL(referrer);
    return url.hostname;
} catch (_) {
    return null;
}
};

const getUTMSource = (params, referringDomain) => {
if (params.has('utm_source')) {
    return params.get('utm_source');
}

if (referringDomain && referringDomain.match(/www\.bing\./)) {
    return 'bing';
}

if (referringDomain && referringDomain.match(/www\.google\./)) {
    return 'google';
}

return null;
};

const getUTMMedium = (params, referringDomain) => {
if (params.has('utm_medium')) {
    return params.get('utm_medium');
}

if (referringDomain && referringDomain.match(/(www\.bing\.|www\.google\.)/)) {
    return 'seo';
}

return null;
};

const getUTMCampaign = (params) => {
if (params.has('utm_campaign')) {
    return params.get('utm_campaign');
}

if (isSEOReferrer()) {
    if (window.location.pathname === '/') {
    return 'branded';
    }

    return 'non-branded';
}

return null;
};

function getUTMProperties() {
const params = new URLSearchParams(window.location.search);

const referrer = getReferrer();
const referring_domain = getReferringDomain(referrer);
const utm_source = getUTMSource(params, referrer);
const utm_medium = getUTMMedium(params, referrer);
const utm_campaign = getUTMCampaign(params);
const utm_term = params.get('utm_term');
const utm_content = params.get('utm_content');

const referrerProperties = {
    referrer,
    referring_domain,
};

const lastProperties = {
    last_referrer: referrer,
    last_referring_domain: referring_domain,
    last_utm_source: params.get('utm_source'),
    last_utm_medium: params.get('utm_medium'),
    last_utm_campaign: params.get('utm_campaign'),
    last_utm_term: params.get('utm_term'),
    last_utm_content: params.get('utm_content'),
};

const utmProperties = {
    utm_source,
    utm_medium,
    utm_campaign,
    utm_term,
    utm_content,
};

const hasNewUTMValue = Object.values(utmProperties).some(Boolean);
const hadAmplitudeSession = window.localStorage.getItem('hadAmplitudeSession') === 'true';

if (!hadAmplitudeSession || hasNewUTMValue) {
    return {
    ...referrerProperties,
    ...lastProperties,
    ...utmProperties,
    };
}

return {
    ...lastProperties,
    ...utmProperties,
};
}

const UTM_PROPERTIES = [
'utm_source',
'utm_medium',
'utm_campaign',
'utm_term',
'utm_content',
];

const REFERRER_PROPERTIES = [
'referrer',
'referring_domain',
];

function unsetUTMProperties(unsetUserProperties, properties) {
const lastProperties = {};
const referrerProperties = {};
const utmProperties = {};

Object.keys(properties).forEach((propertyName) => {
    if (UTM_PROPERTIES.includes(propertyName)) {
    utmProperties[propertyName] = properties[propertyName];
    } else if (REFERRER_PROPERTIES.includes(propertyName)) {
    referrerProperties[propertyName] = properties[propertyName];
    } else {
    lastProperties[propertyName] = properties[propertyName];
    }
});

const hasNewUTMValue = Object.values(utmProperties).some(Boolean);

const propertiesToUnset = hasNewUTMValue
    ? { ...lastProperties, ...referrerProperties, ...utmProperties }
    : lastProperties;

const propertyNames = Object.keys(propertiesToUnset).filter((key) => propertiesToUnset[key] === null);

unsetUserProperties(propertyNames);
}

const createUnsetUserProperties = (amplitude) => {
const amplitudeInstance = amplitude.getInstance();

return function unsetUserProperties(properties) {
    const identifyObject = new amplitude.Identify();

    properties.forEach((propertyName) => {
    identifyObject.unset(propertyName);
    });

    amplitudeInstance.identify(identifyObject);
};
};

const createSetInitialReferrerProperties = (amplitude) => {
const amplitudeInstance = amplitude.getInstance();

return function setInitialReferrerProperties(properties) {
    const identifyObject = new amplitude.Identify();

    identifyObject
    .setOnce('initial_referrer', properties.referrer)
    .setOnce('initial_referring_domain', properties.referring_domain);

    console.log('identifyObject',identifyObject)
    amplitudeInstance.identify(identifyObject);
    window.localStorage.setItem('hadAmplitudeSession', true);
};
};

const initializeUTMProperties = (amplitude) => {
const amplitudeInstance = amplitude.getInstance();

const properties = getUTMProperties();
console.log('prop',properties)
const unsetUserProperties = createUnsetUserProperties(amplitude);
const setInitialReferrerProperties = createSetInitialReferrerProperties(amplitude);

unsetUTMProperties(unsetUserProperties, properties);
// setInitialReferrerProperties(properties);
amplitudeInstance.setUserProperties(properties);
};

// Init amplitude
amplitude.getInstance().init(amplitudeAPIKey, null, {
    saveEvents: true,
    includeUtm: false,
    includeGclid: true,
    includeReferrer: false,
    saveParamsReferrerOncePerSession: false,
    batchEvents: false,
    eventUploadThreshold: 1
}, function (instance) {

    const sessionId = localStorage.getItem(SESSION_KEY);

    currentSession = instance._sessionId;
    if (sessionId != currentSession) {
    localStorage.setItem(SESSION_KEY,currentSession)
    instance.setUserProperties({ 'entrance_uri': window.location.href, 'initial_entrance_uri': window.location.href, 'entrance_time': +new Date });
    initializeUTMProperties(amplitude)
    }

    const uPlatform = navigator.userAgent.match(/Mobi/) ? 'web_mobile' : 'web_desktop';
    instance.setUserProperties({ 'platform': uPlatform, 'content_page': 'newsroom' });

    // window.initializeUTMProperties = initializeUTMProperties;
});
})();


// pageview
amplitude.getInstance().logEvent('newsroom_page_view', {
uri: window.location.href,
referrer: window.document.referrer,
current_page: 'newsroom',
content_page: 'newsroom'
});